export default __webpack_public_path__ + "static/noma-alphabet-chart-b9f4824df840c237df9a5fc3c397fdd2.jpg";